import type { CSSProperties } from "react";

export function ChevronDownIcon({
  color,
  className,
  style,
}: {
  color?: string;
  className?: string;
  style?: CSSProperties;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      className={className}
      style={style}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.62502 4.01709L6.00002 7.39209L9.37502 4.01709L10.1705 4.81258L6.00002 8.98308L1.82953 4.81258L2.62502 4.01709Z"
        fill={color || "currentColor"}
      />
    </svg>
  );
}
